// Supports the catalog screen and a local dialog without changing its parent draft.
export default {
  props: {
    modelValue: { type: Boolean, default: undefined }
  },
  emits: ['update:modelValue', 'saved'],
  data: () => ({ saving: false, saveError: '' }),
  computed: {
    hasPermission () { return this.$store.getters['authModule/hasPermission'] },
    dialogActive () { return this.modelValue === undefined ? this.isDialogActived : this.modelValue },
    canSave () {
      return this.hasPermission(`${this.catalogPermission}.${this.editedItem.id > 0 ? 'update' : 'create'}`)
    }
  },
  watch: {
    dialogActive: {
      immediate: true,
      handler (active) {
        if (!active) return
        this.saveError = ''
        this.initializeEditor()
        this.$nextTick(() => this.$refs.form?.resetValidation())
      }
    }
  },
  methods: {
    close () {
      if (this.saving) return
      if (this.modelValue === undefined) {
        this.$store.dispatch(`${this.catalogModule}/setDialogActived`, false)
        this.$store.dispatch(`${this.catalogModule}/setSelectedItem`, { ...this.defaultItem })
      } else {
        this.$emit('update:modelValue', false)
      }
    },
    async save () {
      if (this.saving || !this.canSave) return
      this.saving = true
      this.saveError = ''
      try {
        const result = await this.$refs.form.validate()
        if (!result.valid) return
        const saved = await this.$store.dispatch(`${this.catalogModule}/${this.catalogSaveAction}`, {
          ...this.editedItem, id: this.editedItem.id > 0 ? this.editedItem.id : null
        })
        this.$emit('saved', saved)
        this.saving = false
        this.close()
      } catch {
        this.saveError = 'No se pudo guardar. Los datos siguen cargados; puede volver a intentar.'
      } finally {
        this.saving = false
      }
    }
  }
}
